import { useBroadcastChannel } from 'hooks/useBroadcastChannel';
import { useEffect } from 'react';
import { EventTypes } from '../constant';

const AUTH_BROADCAST_CHANNEL_NAME = 'clarifai-auth';

/**
 * Broadcasts Login, Logout, and User Verified events to other tabs, which
 * will reload the page if the tab is not in focus.
 */
export const useAuthBroadcastChannel = () => {
  const { message, sendMessage } = useBroadcastChannel(AUTH_BROADCAST_CHANNEL_NAME);

  const sendLoginEvent = () => {
    sendMessage({ eventType: EventTypes.LoggedIn });
  };

  const sendLogoutEvent = () => {
    sendMessage({ eventType: EventTypes.LoggedOut });
  };

  const sendUserVerifiedEvent = () => {
    sendMessage({ eventType: EventTypes.UserVerified });
  };

  const sendUserOnboardedEvent = () => {
    sendMessage({ eventType: EventTypes.UserOnboarded });
  };

  useEffect(() => {
    const eventType = message?.eventType as EventTypes | undefined;

    if (eventType && [EventTypes.LoggedIn, EventTypes.LoggedOut, EventTypes.UserVerified, EventTypes.UserOnboarded].includes(eventType)) {
      if (document.hidden) {
        window?.location?.reload();
      }
    }
  }, [message]);

  return { sendLoginEvent, sendLogoutEvent, sendUserVerifiedEvent, sendUserOnboardedEvent };
};
